(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function initOne(sectionEl) {
    const slider = sectionEl.querySelector(".product-slider");
    if (!slider) return;

    // Prevent double init
    if (slider.classList.contains("is-initialized")) return;

    // Slick path (requires window.jQuery + slick)
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      const $slider = window.jQuery(slider);
      if ($slider.hasClass("slick-initialized")) {
        slider.classList.add("is-initialized");
        return;
      }

      const slidesDesktop = parseInt(sectionEl.dataset.slidesDesktop || "3", 10);
      const slidesMobile = parseInt(sectionEl.dataset.slidesMobile || "1", 10);
      const centerPadding = sectionEl.dataset.centerPadding || "100px";

      $slider.slick({
        slidesToShow: slidesDesktop,
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: centerPadding,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: slidesDesktop } },
          { breakpoint: 767, settings: { slidesToShow: slidesMobile, centerPadding: "40px" } },
          { breakpoint: 480, settings: { slidesToShow: slidesMobile, centerPadding: "24px" } },
        ],
      });

      slider.classList.add("is-initialized");
      return;
    }

    // If slick not available, gracefully do nothing (or you can add scroll-snap fallback here)
  }

  function initAll() {
    document.querySelectorAll('[data-featured-products-slider="true"]').forEach(initOne);
  }

  ready(initAll);

  // Shopify theme editor support (OS2.0)
  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target) initOne(e.target);
  });
})();
